import { render, staticRenderFns } from "./groupFitnessDashboardSettings.vue?vue&type=template&id=0ff75714&scoped=true"
import script from "./groupFitnessDashboardSettings.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff75714",
  null
  
)

export default component.exports